import type { BinaryReader } from '../BinaryReader';
import type { BinaryWriter } from '../BinaryWriter';

/**
 * Mirrors GameStars.Models.NetworkModels.PlayerModel (CommonNetworkModels.cs:224-249).
 * Wire order: UserId(long), Username(string), Avatar(int).
 */
export interface PlayerModel {
  userId: bigint;
  username: string;
  avatar: number;
}

export function decodePlayerModel(r: BinaryReader): PlayerModel {
  return {
    userId: r.getLong(),
    username: r.getString(),
    avatar: r.getInt(),
  };
}

export function writePlayerModel(w: BinaryWriter, p: PlayerModel): void {
  w.putLong(p.userId).putString(p.username).putInt(p.avatar);
}
